import React from 'react'
import { connect } from 'react-redux'
import { Menu } from 'semantic-ui-react'
import SortableOrdersTable from './SortableOrdersTable'
import Header from './Header'
import FormFilters from '../FormFilters'
import OrderScopeFilters from './OrderScopeFilters'
import { defaultFilters } from '../../helpers/orderHelpers'
import { RECONCILED } from '../../constants/search_filters'

class ReconciliationsIndex extends React.Component {
  componentDidMount() {
    // set initial default filters
    this.props.dispatch({
      type: 'SHOP_ORDER_FILTERS_UPDATE',
      payload: { ...defaultFilters(), order_scopes: [RECONCILED] }
    })

    this.props.dispatch({ type: 'SHOP_ORDERS_LOAD_SAGA' })
  }

  render() {
    return (
      <React.Fragment>
        <Menu vertical compact className='side-filter-menu'>
          <FormFilters />
          <OrderScopeFilters isReconciliation />
        </Menu>
        <div className='table-section-wrapper'>
          <Header />
          <SortableOrdersTable isReconciliation />
        </div>
      </React.Fragment>
    )
  }
} // ReconciliationsIndex

const mapStateToProps = (state) => ({})
export default connect(mapStateToProps)(ReconciliationsIndex)
